import { Modal } from "react-bootstrap";
import { useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { AlbumInsert } from "../../apis/api/GalleryApis";
import { useDispatch,useSelector } from "react-redux";
import Cookies from "js-cookie"
import Lodderr from "../../components/Lodder/Lodder";
import { toast } from "react-toastify";
import { albumGet } from "../../apis/api/GalleryApis";
const AddAlbum = ({ show, handleClose }) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const fileInputRef = useRef(null);
  const {loading} = useSelector((state)=>state.GallerySlice)
const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    clearErrors,
    reset
  } = useForm();

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    const updatedFiles = [...selectedFiles, ...files];
    setSelectedFiles(updatedFiles);

    if (updatedFiles.length > 0) {
      clearErrors("files");
    }
  };

  const removeFile = (index) => {
    const updatedFiles = selectedFiles.filter((_, i) => i !== index);
    setSelectedFiles(updatedFiles);

    if (updatedFiles.length === 0) {
      setError("files", {
        type: "manual",
        message: "Please select at least one file",
      });
    }
  };

  const onSubmit = async(data) => {
   const userid = Cookies.get("userID");
   const companyid = Cookies.get("company_id")

    if (selectedFiles.length === 0) {
      setError("files", {
        type: "manual",
        message: "Please select at least one file",
      });
      return;
    }
  
    const formData = new FormData();
    formData.append("title", data.title);
    formData.append("userid", userid);
    formData.append("companyid", companyid);
  
    selectedFiles.forEach((file, index) => {
      formData.append("files[]", file); 
    });
  
   
  const response = await dispatch(AlbumInsert(formData));

  if (response.payload.status === "success"){
   await dispatch(albumGet({company_id:companyid}))
    toast.success("Album inserted succesfully !")
  }
  else{
    toast.error("error while inserting album !")
  }
  
 
  
    reset();
    setSelectedFiles([]);
    handleClose();
  };
  
  return (
    <>
    {loading && <Lodderr/>}
    <Modal show={show} onHide={handleClose} size="md" centered>
      <Modal.Header closeButton>
        <Modal.Title>Upload Albums</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="file-upload-container container-upload">
          
            <input
              type="text"
              placeholder="Enter Album Title"
              className="form-control mb-2"
              {...register("title", { required: "Album title is required" })}
            />
            {errors.title && <p className="text-danger">{errors.title.message}</p>}

          
            {!selectedFiles.length && (
              <div
                className="header12"
                onClick={() => fileInputRef.current.click()}
                style={{ cursor: "pointer" }}
              >
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7 10V9C7 6.23858 9.23858 4 12 4C14.7614 4 17 6.23858 17 9V10C19.2091 10 21 11.7909 21 14C21 15.4806 20.1956 16.8084 19 17.5M7 10C4.79086 10 3 11.7909 3 14C3 15.4806 3.8044 16.8084 5 17.5M7 10C7.43285 10 7.84965 10.0688 8.24006 10.1959M12 12V21M12 12L15 15M12 12L9 15"
                    stroke="#000"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <p>Browse File to upload!</p>
              </div>
            )}
            {errors.files && <p className="text-danger">{errors.files.message}</p>}

          
            <div className="preview-container">
              {selectedFiles.map((file, index) => (
                <div key={index} className="preview-item">
                  {file.type.startsWith("image/") ? (
                    <img src={URL.createObjectURL(file)} alt="Preview" className="preview-img" />
                  ) : file.type.startsWith("video/") ? (
                    <video className="preview-media" controls>
                      <source src={URL.createObjectURL(file)} type={file.type} />
                      Your browser does not support the video tag.
                    </video>
                  ) : (
                    <p>{file.name}</p>
                  )}
                  <button
                    type="button"
                    className="remove-btn"
                    onClick={() => removeFile(index)}
                  >
                    ✖
                  </button>
                </div>
              ))}
            </div>

          
            <input
              ref={fileInputRef}
              id="file"
              type="file"
              onChange={handleFileChange}
              multiple
              hidden
            />
          </div>

          <div className="d-flex justify-content-end mt-3">
            <button type="submit" className="btn btn-primary">
              Upload
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
    </>
  );
};

export default AddAlbum;
